export default __webpack_public_path__ + "static/media/traderjoe.267c1253.svg";